var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('line-chart',{attrs:{"title":"Meilleurs sites","subTitle":"sur la période choisie","colors":_vm.colors,"series":_vm.series,"labels":_vm.labels,"yAxis":_vm.yAxis,"stroke":_vm.stroke,"loading":_vm.loading,"classNames":_vm.classNames}})}
var staticRenderFns = []

export { render, staticRenderFns }